/**
 * @param {array} propertyList - the propertyList generated by filters
 *
 */
export const generateGeoJson = (propertyList) => ({
  type: 'FeatureCollection',
  features: propertyList.map((propertyData, idx) => ({
    id: idx,
    type: 'Feature',
    geometry: {
      type: 'Point',
      description: 'Somewhere',
      coordinates: propertyData.lnglat,
    },
    properties: propertyData, // TODO: should be just property
  })),
});
